export default "__VITE_ASSET__7pODfYFO__"